// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { DocumentFragment } from '../../../../../modules/documents/graphql/DocumentFragment.generated';
import { gql } from '@apollo/client';
import { DocumentFragmentDoc } from '../../../../../modules/documents/graphql/DocumentFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAssetTransferConfirmationDocumentsQueryVariables = Types.Exact<{
  where: Types.DocumentWhereInput;
}>;


export type GetAssetTransferConfirmationDocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: (
        { __typename?: 'Document' }
        & DocumentFragment
      ) | null } | null> | null } };

export type CreateAssetTransferConfirmationDocumentMutationVariables = Types.Exact<{
  input: Types.CreateDocumentInput;
}>;


export type CreateAssetTransferConfirmationDocumentMutation = { __typename?: 'Mutation', createDocument: (
    { __typename?: 'Document' }
    & DocumentFragment
  ) };

export const Operations = {
  Query: {
    GetAssetTransferConfirmationDocuments: 'GetAssetTransferConfirmationDocuments' as const
  },
  Mutation: {
    CreateAssetTransferConfirmationDocument: 'CreateAssetTransferConfirmationDocument' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetAssetTransferConfirmationDocumentsDocument = gql`
    query GetAssetTransferConfirmationDocuments($where: DocumentWhereInput!) {
  documents(where: $where) {
    edges {
      node {
        ...Document
      }
    }
  }
}
    ${DocumentFragmentDoc}`;

/**
 * __useGetAssetTransferConfirmationDocumentsQuery__
 *
 * To run a query within a React component, call `useGetAssetTransferConfirmationDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetTransferConfirmationDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetTransferConfirmationDocumentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAssetTransferConfirmationDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetAssetTransferConfirmationDocumentsQuery, GetAssetTransferConfirmationDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetTransferConfirmationDocumentsQuery, GetAssetTransferConfirmationDocumentsQueryVariables>(GetAssetTransferConfirmationDocumentsDocument, withFetchPolicyContext(options));
      }
export function useGetAssetTransferConfirmationDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetTransferConfirmationDocumentsQuery, GetAssetTransferConfirmationDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetTransferConfirmationDocumentsQuery, GetAssetTransferConfirmationDocumentsQueryVariables>(GetAssetTransferConfirmationDocumentsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetAssetTransferConfirmationDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssetTransferConfirmationDocumentsQuery, GetAssetTransferConfirmationDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssetTransferConfirmationDocumentsQuery, GetAssetTransferConfirmationDocumentsQueryVariables>(GetAssetTransferConfirmationDocumentsDocument, withFetchPolicyContext(options));
        }
export type GetAssetTransferConfirmationDocumentsQueryHookResult = ReturnType<typeof useGetAssetTransferConfirmationDocumentsQuery>;
export type GetAssetTransferConfirmationDocumentsLazyQueryHookResult = ReturnType<typeof useGetAssetTransferConfirmationDocumentsLazyQuery>;
export type GetAssetTransferConfirmationDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetAssetTransferConfirmationDocumentsSuspenseQuery>;
export type GetAssetTransferConfirmationDocumentsQueryResult = Apollo.QueryResult<GetAssetTransferConfirmationDocumentsQuery, GetAssetTransferConfirmationDocumentsQueryVariables>;
export const CreateAssetTransferConfirmationDocumentDocument = gql`
    mutation CreateAssetTransferConfirmationDocument($input: CreateDocumentInput!) {
  createDocument(input: $input) {
    ...Document
  }
}
    ${DocumentFragmentDoc}`;
export type CreateAssetTransferConfirmationDocumentMutationFn = Apollo.MutationFunction<CreateAssetTransferConfirmationDocumentMutation, CreateAssetTransferConfirmationDocumentMutationVariables>;

/**
 * __useCreateAssetTransferConfirmationDocumentMutation__
 *
 * To run a mutation, you first call `useCreateAssetTransferConfirmationDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetTransferConfirmationDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetTransferConfirmationDocumentMutation, { data, loading, error }] = useCreateAssetTransferConfirmationDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetTransferConfirmationDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetTransferConfirmationDocumentMutation, CreateAssetTransferConfirmationDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetTransferConfirmationDocumentMutation, CreateAssetTransferConfirmationDocumentMutationVariables>(CreateAssetTransferConfirmationDocumentDocument, options);
      }
export type CreateAssetTransferConfirmationDocumentMutationHookResult = ReturnType<typeof useCreateAssetTransferConfirmationDocumentMutation>;
export type CreateAssetTransferConfirmationDocumentMutationResult = Apollo.MutationResult<CreateAssetTransferConfirmationDocumentMutation>;
export type CreateAssetTransferConfirmationDocumentMutationOptions = Apollo.BaseMutationOptions<CreateAssetTransferConfirmationDocumentMutation, CreateAssetTransferConfirmationDocumentMutationVariables>;